export default __webpack_public_path__ + "static/media/elecc.ac4f3ded.jpg";